import React from 'react';
import Header from './Header';

const Layout = ({ children, onToggleEditMode, onToggleSentenceBuilder, showSentenceBuilder }) => {
  return (
    <>
      <Header
        onToggleEditMode={onToggleEditMode}
        onToggleSentenceBuilder={onToggleSentenceBuilder}
        showSentenceBuilder={showSentenceBuilder}
      />
      <div style={{ paddingTop: '5px' }}>
        {children}
      </div>
    </>
  );
};

export default Layout;
